export const getRandomToken = (tokens) => {
    const randomToken = tokens[Math.floor(Math.random() * tokens.length)];
    return randomToken;
};


export const getRandomNumberByRange = (start, end) => {
    return Math.floor(Math.random() * (end - start) + start);
};

// 展平数组
export const deepFlatten = arr => [].concat(...arr.map(v => (Array.isArray(v) ? deepFlatten(v) : v)));